import { createSearchParams } from 'react-router-dom';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { replace } from '@lagunovsky/redux-react-router';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { locationSelector } from '../_selectors/location.selector';
import { RouterAction } from '../router.action';

type IState =
  & IGetSelectorStateType<typeof locationSelector>;

export const removeQueryParamEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(RouterAction.removeParam),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { name } = payload;
    const location = locationSelector(state);

    const searchParams = createSearchParams(location.search);
    if (!searchParams.has(name)) {
      return [];
    }

    searchParams.delete(name);

    return [
      replace({
        ...location,
        search: searchParams.toString(),
      }),
    ];
  }),
);
